import React, { Component } from 'react';
import {connect} from 'react-redux'
import InputText from '../components/inputText'
import PropTypes from "prop-types";
import UrlApi from '../../lib/urlApi'

import LocateReserve from '../../lib/locateReserve'

const onClickPrint = (ref) => {
  window.open(`${UrlApi}/order/pdf/${ref}`);
}

const onClickDownload = (ref) => {
  window.location = `${UrlApi}/order/pdf/${ref}?download=true`;
}

class sectionText extends Component {
  static contextTypes = {
    router: PropTypes.object
  }

  constructor(props) {
    super(props);
    this.state = {
      show: false,
      errors: {},
      confirmedReference: ''
    };
  }

  onResult = async (res) => {
    const langUrl = this.context.router.route.location.pathname.split('/')[1]
    const { languages } = this.props.settings
    const langPlace = languages[langUrl].locatereserve
    const resBody = await res.json()

    if (res.status === 200){
      this.setState( {show: true, confirmedReference: resBody.reference, errors: {}} )
    } else {
      this.setState( {show: false, confirmedReference: '', errors: {locatereserve: {isError: true, message: langPlace.error}}} )
    }
  }

  handleSubmit = (event) => {
    event.preventDefault();
    LocateReserve(this.state.reserve, this.onResult)
  }

  onChange = (name, value, title, id) => {
    this.setState({[name]: value })
  }

  render() {
    const langUrl = this.context.router.route.location.pathname.split('/')[1]
    const { languages } = this.props.settings
    const langPlace = languages[langUrl].locatereserve

    const show = this.state.show
    const errors = this.state.errors
    const values = this.state

    const reference = this.state.confirmedReference

    return (
      <div className="container-fluid">

          <section className="section-text">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <h2 className="h3 heavy">{langPlace.title}</h2>
                  <p className="light">{langPlace.description}</p><p>&nbsp;</p>
                </div>
              </div>

              <div className="row">
                <div className='col-lg-12 col-md-12 col-sm-12'>
                  <form onSubmit={this.handleSubmit.bind(this)}>
                    <div className='col-lg-5 col-md-5 col-sm-6 col-xs-12 no-padding'>
                      <InputText name='reserve' title={langPlace.reserve} value={values} errors={errors} section='locate' onChange={this.onChange}/>
                    </div>
                    <div className='general-button button-next col-lg-2 col-md-2 col-sm-4 col-xs-12' style={{margin: '0px 20px', background: '#1d3767'}} onClick={this.handleSubmit}>
                      {langPlace.buttonsearch}<i className="fa fa-angle-right" aria-hidden="true"></i>
                    </div>
                  </form>
                </div>
              </div>
              {(show)?
                <div className='col-lg-12 col-md-12 col-sm-12'>
                  <div className='row separating-line'><hr/></div>
                  <div className='row section-middle-paragraph'>
                    {langPlace.message}
                  </div>
                  <div className='row'>
                    <div className='display-flex-end'>
                      <div className='general-button button-normal' onClick={() => onClickPrint(reference)} >
                        {langPlace.buttonprint}<i className="fa fa-print" aria-hidden="true"></i>
                      </div>
                      <div className='general-button button-normal' onClick={() => onClickDownload(reference)}>
                        {langPlace.buttondownload}<i className="fa fa-download" aria-hidden="true"></i>
                      </div>
                    </div>
                  </div>
                </div>
              :''}
              </div>
          </section>

      </div>
    );
  }
}

export default connect(
  (state) => ({settings: state.settings, data: state.data}),
)(sectionText)



// WEBPACK FOOTER //
// ./src/shared/routes/routeSectionText/sectionText.js